import { createActionName } from "redux/utility"

export const reducerName = "imported"

// Actions
export const IMPORTED_USER = createActionName(reducerName, "IMPORTED_USER")
export const IMPORTED_USERS = createActionName(reducerName, "IMPORTED_USERS")
